<template>
  <div class="cropper-content">
    <div class="cropper-box">
      <div class="cropper">
        <vue-cropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :canScale="option.canScale"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :full="option.full"
          :fixedBox="option.fixedBox"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :centerBox="option.centerBox"
          :height="option.height"
          :infoTrue="option.infoTrue"
          :maxImgSize="option.maxImgSize"
          :enlarge="option.enlarge"
          :mode="option.mode"
          @realTime="realTime"
          @imgLoad="imgLoad"
        ></vue-cropper>
      </div>
    </div>
    <!--底部操作工具按钮-->
    <div class="footer-btn">
      <div class="scope-btn">
        <label class="btn" for="uploads">上传图片</label>
        <input
          type="file"
          id="uploads"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="selectImg($event)"
        />
        <el-button
          icon="ZoomIn"
          size="mini"
          circle
          @click="changeScale(1)"
        ></el-button>
        <el-button
          icon="ZoomOut"
          size="mini"
          circle
          @click="changeScale(-1)"
        ></el-button>
        <el-button  icon="Back"
          size="mini"
          circle @click="rotateLeft">
        </el-button>
        <el-button  icon="Right"
          size="mini"
          circle @click="rotateRight">
        </el-button>
        <el-button size="mini" type="success" @click="uploadImg('blob')">
          确认上传
          <Upload />
        </el-button>
      </div>
      <!-- <div class="upload-btn">
        <el-button size="mini" type="success" @click="uploadImg('blob')">
          确认上传
          <Upload />
        </el-button>
      </div> -->
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="footer-title">结果</div>
        <div>
          <div>总条数:{{ result.detected_regions }}</div>
          <br />
          <el-image
            style="width: 100%; height: 200px"
            :src="result.upload"
            :preview-src-list="result.upload"
          ></el-image>
        </div>
      </div>
    </div>
    <!--预览效果图-->
    <!-- <div class="show-preview">
      <div :style="previews.div" class="preview">
        <img :src="previews.url" :style="previews.img" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import imageService from '@/api/imageService'
export default {
  name: 'CropperImage',
  components: {
    VueCropper
  },
  // props: ['Name'],
  data() {
    return {
      // name: this.Name,
      previews: {},
      option: {
        img: '', //裁剪图片的地址
        outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg', //裁剪生成图片的格式（jpeg || png || webp）
        info: true, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: window.innerWidth * 0.7, // 屏幕宽度70%
        autoCropHeight: (window.innerWidth * 0.7) / 1.53, // 按比例计算高度
        fixed: true,
        fixedNumber: [1.53, 1],
        full: false,
        fixedBox:false, // 启用自由拖拽
        canRotate: true, // 启用拖拽旋转
        rotateStep: 1, // 设置1度步进
        canMove: true, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: false, //截图框是否被限制在图片里面
        height: false, //是否按照设备的dpr 输出等比例图片
        infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: '230px 150px' //图片默认渲染方式
      },
      result: {
        url: '',
        detected_regions: 0
      }
    }
  },
  methods: {
    //初始化函数
    imgLoad(msg) {
      console.log('工具初始化函数=====111' + msg)
    },
    //图片缩放
    changeScale(num) {
      if (!this.$refs?.cropper) return
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    //向左旋转
    rotateLeft() {
      if (!this.$refs?.cropper) return
      this.$refs.cropper.rotate -= (1 / 90)
      this.$refs.cropper.goAutoCrop
    },
    //向右旋转
    rotateRight() {
      if (!this.$refs?.cropper) return
      this.$refs.cropper.rotate += (1 / 90)
      this.$refs.cropper.goAutoCrop
    },
    //实时预览函数
    realTime(data) {
      this.previews = data
    },
    //选择图片
    selectImg(e) {
      let file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|webp|JPG|PNG|WEBP)$/.test(e.target.value)) {
        this.$message({
          message: '图片类型要求：jpeg、jpg、png、webp',
          type: 'error'
        })
        return false
      }
      //转化为blob
      let reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        // 赋值选择图片的地址
        this.option.img = data
      }
      //转化为base64
      reader.readAsDataURL(file)
    },
    //上传图片
    uploadImg(type) {
      if (!this.$refs?.cropper) return
      let _this = this
      if (type === 'blob') {
        if (!this.$refs.cropper) return
        this.$refs.cropper.getCropBlob(async data => {
          let formData = new FormData()
          // formData.append("userId", "当前用户ID"); // 需要替换为实际用户ID
          formData.append('avatar', data, 'cropped-image.jpg')

          try {
            const response = await imageService.upload(formData)
            this.$message.success('上传成功')
            this.result = { ...response.data.data }
            console.log('上传响应：', response.data)
          } catch (error) {
            this.$message.error('上传失败')
            console.error('上传错误：', error)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cropper-content {
  flex-direction: column;
  height: auto;
  width: 100%;
  .cropper-box {
    width: 100%;
    height: 50vh;
    min-height: 300px;
  }
  .footer {
    width: 100%;
    margin-top: 20px;
    .footer-title{
      text-align:left;
    }
  }

  .footer-btn {
    flex-direction: column;
    align-items: flex-start;
    .scope-btn {
      flex-wrap: wrap;
      gap: 8px;
    }
  }

  ::v-deep .cropper {
    height: 100% !important;
  }
  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    .preview {
      overflow: hidden;
      border: 1px solid #67c23a;
      background: #cccccc;
    }
  }

  .footer-btn {
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    .scope-btn {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding-right: 10px;
    }
    .upload-btn {
      flex: 1;
      -webkit-flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
    }
    .btn {
      outline: none;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      -webkit-transition: 0.1s;
      transition: 0.1s;
      font-weight: 500;
      padding: 8px 15px;
      font-size: 12px;
      line-height: 15px;
      border-radius: 3px;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      margin-right: 10px;
    }
  }
}
</style>
